module.exports = __webpack_public_path__ + "static/img/3_phase_function_Paper_Points.c62739d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3_phase_function_Paper_Points.png
// module id = XADG
// module chunks = 0